export default "__VITE_ASSET__BkA3uMOZ__"